import { useMemo } from "react";
import {
  TopicWithScore,
  useCategoryPageData,
  useTopicsWithScore,
} from "../../../../../FuturebilityCockpit/hooks";
import { Category } from "../../../../../FuturebilityCockpit/types";
import { ParticipationHeaderProps } from "./../types";

interface UseReflectionDataReturn {
  itemizedAverageScoreData: Array<{
    questionTitle: string;
    averageScore: number;
  }>;
  topic: ReturnType<typeof useTopicsWithScore>[0];
}

export function useReflectionData({
  publicTest,
  currentSet,
}: ParticipationHeaderProps): UseReflectionDataReturn {
  const originalTestSet = useMemo(
    () => publicTest.sets.find(ts => ts._id === currentSet.originalTestSetId),
    [publicTest.sets, currentSet.originalTestSetId]
  );

  const rawData = {
    testSets: originalTestSet ? [originalTestSet] : [],
    allEntries: publicTest.entries,
    client: publicTest.client,
    tests: [publicTest],
    dynamicTestSets: [],
  };

  const currentCategoryData = useCategoryPageData({
    currentTestId: publicTest._id,
    currentCategory: originalTestSet?.category as Category,
    selectedFilters: undefined,
    rawData,
  });

  const topics = useTopicsWithScore({
    currentTestId: publicTest._id,
    selectedFilters: undefined,
    rawData,
  });

  // use topic with score or minimal object with name
  const topic =
    topics.length > 0
      ? topics[0]
      : ({ name: currentSet?.info?.name ?? "N/A" } as TopicWithScore);

  return {
    itemizedAverageScoreData: currentCategoryData.itemizedAverageScoreData,
    topic,
  };
}
